const { default: axios } = require("axios");

const FormAjax = function () {

    const formAjax = function (e) {

        //const values = form.serialize();
        const form = $(this);
        var values = new FormData(this);
        const button = form.find('button');

        //Recaptcha Google V2 box
        var reCaptchaValided    = true;
        var hasRecaptcha        = false;

        form.find('.custom-captcha-error').hide();
        if( form.find("[name=g-recaptcha-response]").length > 0 ) {
            hasRecaptcha = true;
            if ( form.find("[name=g-recaptcha-response]").val() === '' ) {
                e.preventDefault();
                form.find('.custom-captcha-error').show();
                reCaptchaValided = false;
            }
        }

        if(!reCaptchaValided){
            return false;
        }

        button.attr('disabled', 'disabled');
        button.find('p').text('ENVIANDO...');

        Swal.fire({
            title: '',
            allowOutsideClick: false,
            showCancelButton: false,
            showCloseButton: false,
            background:'transparent',
            didOpen: () => {
                Swal.showLoading()
            }
        });

        axios.post(form.attr('action'), values)
            .then(function (response) {
                const data = response.data;

                Swal.close();

                Swal.fire({
                    icon: data.error == false ? 'success' : 'error',
                    title: data.message,
                    showConfirmButton: false,
                    timer: 3000
                })

                if(hasRecaptcha){
                    var c = $('.g-recaptcha').length;
                    for (var i = 0; i < c; i++)
                        grecaptcha.reset(i);
                }

                button.removeAttr('disabled');
                button.find('p').text('ASSINAR');

                form.trigger("reset");

            }).catch( error => {
                Swal.fire({
                    icon: 'error',
                    title: error,
                    showConfirmButton: true,
                    timer: 3000
                })
                console.log(error);
                button.removeAttr('disabled');
                button.find('p').text('ASSINAR');
            });

        e.preventDefault();
    }

    const CaptchaCallback = function() {
        $('.g-recaptcha').each(function(index, el) {
            grecaptcha.render(el, {
                'sitekey'           : $(el).attr('data-sitekey')
                ,'theme'            : $(el).attr('data-theme')
                ,'size'             : $(el).attr('data-size')
                ,'tabindex'         : $(el).attr('data-tabindex')
                ,'callback'         : $(el).attr('data-callback')
                ,'expired-callback' : $(el).attr('data-expired-callback')
                ,'error-callback'   : $(el).attr('data-error-callback')
            });

        });
    };

    return {
        init: function () {
            $(document).on('submit', '.form-ajax', formAjax);
            // CaptchaCallback();

        }
    }
}();

module.exports = FormAjax;
